<template>
  <div class="illustration-component inner">
    <img src="../assets/attendance.jpg" class="illustration-img"/>
    <img src="../assets/logo_shadow.svg" class="logo" />
  </div>
</template>
<script>
  export default {
    name: 'illustration-component',
  }
</script>
<style scoped lang="scss">
  .illustration-component {
    position: relative;
    .illustration-img {
      width: 100%;
    }
    .logo {
      position: absolute;
      bottom: 20px;
      right: 20px;
      width: 220px;
    }
  }
  @media (max-width: 500px) {
    .illustration-component {
      display: none;
    }
  }
</style>